import { connect, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import React, { useCallback, useMemo, useRef, useState } from "react";
import {
  CAlert,
  CButton,
  CCol,
  CForm,
  CFormInput,
  CFormLabel,
  CFormSelect,
  CInputGroup,
  CInputGroupText, CModal, CModalBody, CModalHeader, CModalTitle,
  CRow
} from "@coreui/react";
import { AgGridReact } from "ag-grid-react";
import { Loading } from "../../../components/common";

import * as api from "../../../api/api";
import StoreDetail from "./StoreDetail";
import StoreListWhere from "../where/StoreListWhere";
import StoreCornerListWhere from "../where/StoreCornerListWhere";

const StoreList = (props) => {
  const { user } = useSelector((props) => props.account);
  const navigate = useNavigate();

  const [searchForm, setSearchForm] = useState({
    cmpCd: "",
    brandCd: "",
    storeCd: "",
    storeNm: "",
    manageDiv: "0"
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState({visible: false, message: ""});

  const [rowData, setRowData] = useState([]);
  const [visible, setVisible] = useState(false);
  const [selectedStore, setSelectedStore] = useState({});

  const manageDivFormatter = (params) => {
    const manageDiv = params.value;
    switch (manageDiv) {
      case "1":
        return "직영";
      case "2":
        return "가맹";
      case "3":
        return "일반";
    }
  };

  const [columnDefs] = useState([
    { field: "seq", headerName: "No", width: 100 },
    { field: "type", headerName: "용도", width: 100 },
    { field: "manageDiv", headerName: "매장그룹", valueFormatter: manageDivFormatter, width: 100 },
    { field: "storeCd", headerName: "매장코드", width: 120 },
    { field: "storeNm", headerName: "매장명" },
    { field: "ownerNm", headerName: "대표자명" },
    { field: "telNo", headerName: "전화번호" },
    { field: "mobileNo", headerName: "휴대전화" },
    { field: "status", headerName: "상태구분" },
    { field: "openDt", headerName: "시스템오픈" }
  ]);

  const info = () => {

  };

  const search = async () => {
    const {cmpCd, brandCd, storeCd} = searchForm;
    if (cmpCd.length === 0) {
      setError({
        visible: true,
        message: "운영사 정보를 선택해주세요."
      });
      return;
    }

    const params = {
      cmpCd: cmpCd,
      brandCd: brandCd,
      storeCd: storeCd,
      userId: user.userId,
      storeNm: searchForm.storeNm,
      manageDiv: searchForm.manageDiv
    };
    setLoading(true);
    try {
      const { data: result } = await api.getStoreWhere(params);
      const { responseBody, responseCode, responseMessage } = result;
      if (responseCode === "200") {
        // 성공
        setRowData(responseBody);
      } else {

      }
    } catch (e) {
      console.error(e.message);
    } finally {
      setLoading(false);
    }
  };

  const containerStyle = useMemo(() => ({ width: "100%", height: "100%" }), []);
  const gridStyle = useMemo(() => ({ height: 450, width: "100%" }), []);

  const onRowSelected = useCallback((event) => {
    setSelectedStore(event.node.data);
    setVisible(true);

    console.log("store : ", event.node.data);

  }, []);

  const handleSelect = (code, value) => {
    if (value === "C") {
      setSearchForm((state) => ({
        ...state,
        cmpCd: code
      }));
    } else if (value === "B") {
      setSearchForm((state) => ({
        ...state,
        brandCd: code
      }));
    } else if (value === "S") {
      setSearchForm((state) => ({
        ...state,
        storeCd: code
      }));
    } else if (value === "O") {
      setSearchForm((state) => ({
        ...state,
        cornerCd: code
      }));
    }
  };

  return (
    <div style={containerStyle}>
      {loading ? <Loading/> : null}
      {error.visible ? <CAlert color="danger">{error.message}</CAlert> : null}
      <div className="d-grid gap-1 d-md-flex justify-content-between" style={{marginBottom: 10}}>
        <h5>매장정보조회</h5>
        <div className="d-grid gap-1 d-md-flex justify-content-md-end">
          <CButton color="dark" onClick={search}>조회</CButton>
        </div>
      </div>
      <CForm>
        <StoreCornerListWhere type={"S"} account={props.account} selected={searchForm}
                        onSelect={(c, v) => handleSelect(c, v)}/>
        <CRow>
          <CInputGroup className={"mb-1"} size={"sm"}>
            <CInputGroupText style={{ width: 80 }}>형태</CInputGroupText>
            <CFormSelect id="manageDiv"
                         value={searchForm.manageDiv}
                         onChange={(e) => {
                           setSearchForm((state) => ({
                             ...state,
                             manageDiv: e.target.value
                           }));
                         }}
            >
              <option value={"0"}>전체</option>
              <option value={"1"}>직영</option>
              <option value={"2"}>가맹</option>
            </CFormSelect>
          </CInputGroup>
        </CRow>
      </CForm>
      <div style={{ height: 10 }}/>
      <div className="ag-theme-alpine" style={gridStyle}>
        {loading ? <Loading/> : null}
        <AgGridReact
          rowSelection={"single"}
          onRowDoubleClicked={onRowSelected}
          rowData={rowData}
          pagination={true}
          suppressDragLeaveHidesColumns={true}
          columnDefs={columnDefs}>
        </AgGridReact>
      </div>

      <CModal size={"lg"} backdrop={"static"} alignment={"center"} visible={visible} onClose={() => setVisible(false)}>
        <CModalHeader>
          <CModalTitle>매장 상세정보</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <StoreDetail info={selectedStore}/>
        </CModalBody>
      </CModal>
    </div>
  );
};

const mapStateToProps = (state) => {
  const { account, store, selected } = state;
  return {
    account, store, selected
  };
};

export default connect(mapStateToProps, null)(StoreList);
